var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"display-none"},[_c('p',{staticClass:"m0"},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('small',[_vm._v("© 2017 Maich Swift Architects Ltd")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-735dc974","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/AppFooter.vue
// module id = TJQs
// module chunks = 1